// src/comps/SyncOverlay.js
import React from 'react';

const SyncOverlay = ({ visible, pendingCount, message }) => {
    if (!visible) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.75)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 99999,
            color: '#fff',
            fontFamily: 'Arial, sans-serif',
        }}>
            <div style={{
                background: '#fff',
                borderRadius: '16px',
                padding: '40px 50px',
                textAlign: 'center',
                color: '#333',
                maxWidth: '420px',
                boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
            }}>
                {/* Spinning icon */}
                <div style={{
                    width: '60px',
                    height: '60px',
                    border: '4px solid #e0e0e0',
                    borderTop: '4px solid #17a2b8',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    margin: '0 auto 20px',
                }} />

                <h3 style={{ margin: '0 0 10px', fontSize: '20px', fontWeight: '600' }}>
                    {message || 'Syncing Offline Data...'}
                </h3>
                
                <p style={{ margin: '0 0 15px', color: '#666', fontSize: '14px' }}>
                    Please wait while we sync your offline data to the server.
                    <br />Do not close or refresh the app.
                </p>

                {pendingCount > 0 && (
                    <div style={{
                        background: '#f0f9ff',
                        border: '1px solid #17a2b8',
                        borderRadius: '8px',
                        padding: '10px 15px',
                        fontSize: '14px',
                        color: '#17a2b8',
                        fontWeight: '500',
                    }}>
                        📤 {pendingCount} records pending sync
                    </div>
                )}

                {/* CSS for spin animation */}
                <style>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </div>
        </div>
    );
};

export default SyncOverlay;